import liff from "@line/liff"
import {API} from "aws-amplify"
import {AppCenterApiName} from "services/constants"

/**
 *
 * @param {'authed' | 'unauthed'} menuType
 */
export const changeLineMenuRequest = async menuType => {
  await liff.ready
  return API.post(AppCenterApiName.AppCenterApiWithToken, "/set-line-menu", {
    body: {
      userId: liff.getDecodedIDToken()?.sub,
      menuId:
        menuType === "authed"
          ? process.env.GATSBY_LINE_RICH_MENU_AUTHED
          : process.env.GATSBY_LINE_RICH_MENU_UNAUTHED,
    },
  })
}
